
import { defineComponent } from 'vue';
import type VueI18n from 'vue-i18n';
import { trackError } from '@white-label-helper/ga-tracking';
import { INTERCEPTION_HTTP_STATUSES } from '@white-label-configuration/constants';
import { Button } from 'ui-shared-components';

export default defineComponent({
  name: 'ErrorPage',

  components: {
    CavuButton: Button,
  },

  computed: {
    title (): VueI18n.TranslateResult {
      return (this.statusCode === 404)
        ? this.$t('pages.error.404.title')
        : this.$t('pages.error.default.title');
    },

    subtitle (): VueI18n.TranslateResult {
      return (this.statusCode === 404)
        ? this.$t('pages.error.404.subtitle')
        : this.$t('pages.error.default.subtitle');
    },
    statusCode (): number {
      return INTERCEPTION_HTTP_STATUSES.find(code =>
          this.$route.path.includes(code.toString()),
      ) || 404;
    },
  },

  mounted () {
    trackError(this.$gtm, this.subtitle || this.title);
  },
});
